import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

import { desktopCSS } from '@measures/responsive'

export interface DrawerContainerProps {
  open: boolean
  children: React.ReactNode
  onClose: () => void
  direction?: 'left' | 'right'
}

type DrawerContentProps = Pick<DrawerContainerProps, 'open' | 'direction'>

const DrawerContent = styled.div<DrawerContentProps>`
  ${({
    theme: {
      colors: { fillDefault },
      animation: {
        transition: { default: defaultTransition },
      },
    },
    open,
    direction,
  }) => css`
    position: fixed;
    z-index: 10001;

    top: 0;
    bottom: 0;

    background-color: ${fillDefault};
    transition: ${defaultTransition};

    ${direction === 'right' &&
    css`
      right: 0;
      transform: translate3d(${open ? 0 : '100%'}, 0, 0);

      @starting-style {
        transform: translate3d(100%, 0, 0);
      }
    `}

    ${direction === 'left' &&
    css`
      left: 0;
      transform: translate3d(${open ? 0 : '-100%'}, 0, 0);

      @starting-style {
        transform: translate3d(-100%, 0, 0);
      }
    `}

    width: 100%;

    ${desktopCSS(css`
      width: 400px;
    `)}
  `}
`

const DrawerOverlay = styled.div<Pick<DrawerContainerProps, 'open'>>`
  ${({
    theme: {
      animation: {
        transition: { fast: fastTransition, default: defaultTransition },
      },
      colors: { staticBlack },
    },
    open,
  }) => css`
    position: fixed;
    z-index: 10000;

    width: 100vw;
    height: 100vh;

    top: 0;
    bottom: 0;
    left: -100vw;
    right: 0;

    opacity: 0;
    transition: opacity ${fastTransition};
    background: ${staticBlack};

    ${open &&
    css`
      opacity: 0.7;
      left: 0;
      transition: opacity ${defaultTransition};
    `}

    @starting-style {
      opacity: 0;
    }
  `}
`

const DrawerContainer: FunctionComponent<DrawerContainerProps> = ({
  direction = 'left',
  open,
  onClose,
  children,
}) => (
  <>
    <DrawerContent direction={direction} open={open}>
      {children}
    </DrawerContent>
    <DrawerOverlay open={open} onClick={onClose} />
  </>
)

export default DrawerContainer
